import { Component, Fragment } from 'react';
import UserBehaviorLogger from '../../../../../../../shared/UserBehaviorLogger';
import { IPageDataState } from '../../../store/pageData';

interface IProps {
  pageData: IPageDataState;
}

export default class UserBehaviorLoggerPageView extends Component<IProps> {
  /**
   *
   */
  public componentDidMount() {
    // ユーザのlocalStorageにもPageView情報を落とす
    UserBehaviorLogger.logPageView(this.props.pageData);
  }
  /**
   *
   */
  public render() {
    return <Fragment />;
  }
}
